module.exports = __webpack_public_path__ + "img/img-2.b63f61e6.webp";